import React, { useState } from 'react'
import './Search.scss'
import { FiSearch } from "react-icons/fi";
import { MdClear } from "react-icons/md";


const Index = ({ searchCallBack, placeholder, className, inputRef, handleSubmit, showClearButton }: any) => {
    const [searchValue, setSearchValue] = useState('')
    let debounce: any;
    const handleSearch = (e: any) => {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
            setSearchValue(e)
            searchCallBack(e)
        }, 1000);
    }

    const clearSearchTab = () => {
        if (inputRef?.current) {
            inputRef.current.value = "";
        }
    }
    return (
        <>
            <div className="position-relative">
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(searchValue); setSearchValue('') }}>
                    <span className='position-absolute search-icon'><FiSearch /></span>
                    <input
                        className={[className,].join(' ')}
                        autoComplete="off"
                        type="text"
                        name="keyword"
                        id="search"
                        placeholder={placeholder ? placeholder : 'Search'}
                        // defaultValue={searchKeyword}
                        ref={inputRef}
                        onChange={(e) => {
                            handleSearch(e.target.value);
                        }}
                    />
                    {(showClearButton && inputRef?.current?.value) && (
                        <MdClear
                            style={{
                                position: "absolute",
                                right: "20px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                // color: "gray",
                                fontSize: "20px"
                            }}
                            onClick={() => { handleSearch(""); clearSearchTab() }}
                        />
                    )}
                </form>
            </div>
        </>

    )
}

export default Index